import React, { useMemo } from 'react';
import { OpenCampaignCardAspectRatio, OpenCampaignCardMedia } from '@lux/campaign-card';
import { getCampaignImage, getCampaignMobileImage } from '../utils';
var getMedia = function (campaign, aspectRatio) {
    if (aspectRatio === OpenCampaignCardAspectRatio.Mobile) {
        return getCampaignMobileImage(campaign, { omitQueryParams: true });
    }
    return aspectRatio
        ? getCampaignImage(campaign, aspectRatio, { omitQueryParams: true })
        : undefined;
};
export var CampaignCardMedia = function (_a) {
    var aspectRatio = _a.aspectRatio, aspectRatioXs = _a.aspectRatioXs, aspectRatioSm = _a.aspectRatioSm, aspectRatioMd = _a.aspectRatioMd, campaign = _a.campaign;
    var image = useMemo(function () {
        var media = getMedia(campaign, aspectRatio);
        var xsMedia = getMedia(campaign, aspectRatioXs || aspectRatio);
        var smMedia = getMedia(campaign, aspectRatioSm);
        var mdMedia = getMedia(campaign, aspectRatioMd);
        return {
            alt: media.altText,
            src: media.url,
            xsSrc: xsMedia === null || xsMedia === void 0 ? void 0 : xsMedia.url,
            smSrc: smMedia === null || smMedia === void 0 ? void 0 : smMedia.url,
            mdSrc: mdMedia === null || mdMedia === void 0 ? void 0 : mdMedia.url,
        };
    }, [aspectRatio, aspectRatioMd, aspectRatioSm, aspectRatioXs, campaign]);
    return React.createElement(OpenCampaignCardMedia, { image: image });
};
